export const RouteGetAuthSsoLogin = "/auth/sso/login";

export interface QueryParamsGetAuthSsoLogin {
  frontendOrigin: string;
  redirectBaseUrl: string;
}

export interface ResponseGetAuthSsoLogin {
  ssoLoginUrl: string;
}
